export default {
  bad: [
    {
      IdPaso: -1,
      DescripcionPaso: "¡Pronto te llamaremos!",
      Orden: 1,
      Identificacion: "CC789"
    },
    {
      IdPaso: -1,
      DescripcionPaso:
        "Dirígete a la sala del piso indicado y espera el llamado del profesional orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text everorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever",
      Orden: 2,
      Identificacion: "CC789"
    }
  ],
  good: [
    {
      IdPaso: 1,
      DescripcionPaso: "¡Pronto te llamaremos!",
      Orden: 1,
      Identificacion: "CC789"
    },
    {
      IdPaso: 2,
      DescripcionPaso:
        "Dirígete a la sala del piso indicado y espera el llamado del profesional orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever orem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever",
      Orden: 2,
      Identificacion: "CC789"
    }
  ]
};